import React from 'react';

const noop = () => undefined;

const defaultBotContext = {
  // Global
  resetOnClose: false,
  autofocusComposer: false,
  isDemo: false,
  // Header
  name: '',
  logo: '',
  showName: false,
  showLogo: false,
  showDateTime: false,
  showClose: false,
  title: '',
  subtitle: '',
  // Launcher
  showlauncher: false,
  launcherLogoUrl: '',
  // CTA
  showCta: false,
  setShowCta: noop,
  ctaText: '',
  setCtaText: noop,
  // Banner
  hasSeenBanner: false,
  // Body
  messages: [],
  setMessages: noop,
  MessageWrapper: ({ children }) => children,
  GroupWrapper: ({ children }) => children,
  showPoweredByUbisend: true,
  footerUrl: null,
  footerImageUrl: null,
  // Avatars
  showAvatars: false,
  botAvatarUrl: '',
  humanAvatarUrl: '',
  // Burger
  showBurgerIcon: false,
  showBurgerMenu: false,
  setShowBurgerMenu: () => {},
  buttons: [],
  // Lightbox
  iframeModal: '',
  setIframeModal: noop,
  // Handlers
  resetBot: false,
  // Event Hooks.
  onWidgetShow: noop,
  onWidgetOpen: noop,
  onWidgetClose: noop,
  onCtaHide: noop,
  onIframeModalOpen: noop,
  onIframeModalClose: noop
};

const BotContext = React.createContext(defaultBotContext);

export default BotContext;
export { defaultBotContext };
